import { ValidationLevel, ValidationProps } from 'ui';

export interface ServerValidationMessage {
  message: string;
  parameters: any;
}

export type ServerValidationTypes = (ServerValidationMessage | string)[];
export interface ServerValidationErrors {
  [propertyName: string]: ServerValidationTypes;
}

export const validationFromServer = (serverErrors: any) =>

  Object.keys(serverErrors).reduce((m, field) => {
    return {
      ...m,
      [field]: {
        level: ValidationLevel.error,
        messages: [
          {
            level: ValidationLevel.error,
            message: serverErrors[field][0]
          }
        ]
      }
    };
  }, {} as { [key: string]: ValidationProps });

  export const mapValidationErrorsFromServer = (messages: ServerValidationTypes): ValidationProps => {
    return {
      level: ValidationLevel.error,
      messages: Array.isArray(messages) ? messages.map(m => (
        typeof m === 'object'
          ? {
            level: ValidationLevel.error,
            message: m.message,
            parameters: m.parameters
          }
          : {
            level: ValidationLevel.error,
            message: m
          }
      )) 
        : [{
          level: ValidationLevel.error,
          message: messages
        }]
    };
  };
  
  export const complexValidationFromServer = (serverErrors: ServerValidationErrors): { [propertyName: string]: ValidationProps } => {
    return Object.keys(serverErrors).reduce((prev, propertyName) => {
      const errors = serverErrors[propertyName];
      return {
        ...prev,
        [propertyName]: mapValidationErrorsFromServer(errors)
      };
    }, {});
  };
  
  export const createValidationError = (message?: string): ValidationProps => {
    return {
      level: ValidationLevel.error,
      messages: message ? [{
        level: ValidationLevel.error,
        message: message
      }] : []
    };
  };
